import { render, staticRenderFns } from "./AddendumArea.vue?vue&type=template&id=72dcb346&scoped=true&"
import script from "./AddendumArea.vue?vue&type=script&lang=js&"
export * from "./AddendumArea.vue?vue&type=script&lang=js&"
import style0 from "./AddendumArea.vue?vue&type=style&index=0&id=72dcb346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dcb346",
  null
  
)

export default component.exports